<template>
    <div>
        <div class="container card p-4">
            <div class="row mb-3">
                <div class="col-12">
                    <h5>Filters</h5>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-md-4 mb-2">
                    <label>Plechtigheid van - t/m</label><icon class="ml-2" name="info-circle" v-tooltip="'Datumfilter toont alleen locaties/companies MET (1 of meer) plechtigheden'" />
                </div>
                <div class="col-md-3 mb-2">
                    <label>Company</label>
                </div>
                <div class="col-md-3 mb-2">
                    <label>Locatie</label>
                </div>
                <div class="col-md-2 mb-2">
                    <label>Locatie type</label>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-md-2 mb-2">
                    <datetime-picker v-model="filtering.ceremonyFrom" placeholder="Datum van" type="date"
                                     inputClass="form-control form-control-sm" class="theme-company"
                                     :format="'dd-MM-yyyy'" @input="fetchAll(1)"/>
                </div>
                <div class="col-md-2 mb-2">
                    <datetime-picker v-model="filtering.ceremonyTo" placeholder="Datum t/m" type="date"
                                     inputClass="form-control form-control-sm" class="theme-company"
                                     :format="'dd-MM-yyyy'" @input="fetchAll(1)"/>
                </div>
                <div class="col-md-3 mb-2">
                    <input type="text" class="form-control form-control-sm" placeholder="Zoek bij naam" v-model="filtering.company_name" @keydown.enter="fetchAll(1)" @blur="fetchAll(1)">
                </div>
                <div class="col-md-3 mb-2">
                    <input type="text" class="form-control form-control-sm" placeholder="Zoek bij naam" v-model="filtering.location_name" @keydown.enter="fetchAll(1)" @blur="fetchAll(1)">
                </div>
                <div class="col-md-2 mb-2">
                    <select class="form-control form-control-sm" v-model="filtering.locationType" @change="fetchAll(1)">
                        <option :value="null">Alle types</option>
                        <option :value="1">Normal</option>
                        <option :value="2">2GO</option>
                    </select>
                </div>
            </div>
        </div>

        <Companies :companies="companies" @company-selected="handleCompanySelected" @getCompanies="fetchCompanies" :ordering="ordering.companyCreatedAt" class="mt-5"/>
        <hr class="mb-5 mt-5">
        <Locations :locations="locations" :companyId="selectedCompany" @getLocations="fetchLocations" :ordering="ordering.locationCreatedAt" />
    </div>
</template>

<script>
    import Companies from "./Companies.vue";
    import Locations from "./Locations.vue";
    import DatetimePicker from "../../../components/DatetimePicker.vue";
    import moment from "moment";

    export default {
        components: {DatetimePicker, Locations, Companies},

        data() {
            return {
                selectedCompany: null,
                locations: {},
                companies: {},

                filtering: {
                    ceremonyFrom: null,
                    ceremonyTo: null,
                    company_name: null,
                    location_name: null,
                    locationType: null
                },

                ordering: {
                    companyCreatedAt: 'created_at,desc',
                    locationCreatedAt: 'created_at,desc',
                }
            }
        },

        mounted() {
            this.loadFiltersFromUrl();
            this.fetchAll();
        },

        methods: {
            fetchAll(page = undefined) {
                this.updateUrlWithFilters();
                this.fetchCompanies({page: page, order: this.ordering.companyCreatedAt});
                this.fetchLocations({page: page, order: this.ordering.locationCreatedAt});
            },

            handleCompanySelected(companyId) {
                this.selectedCompany = companyId;
            },

            updateUrlWithFilters() {
                const params = new URLSearchParams();

                if (this.filtering.ceremonyFrom) {
                    params.append('ceremonyFrom', this.filtering.ceremonyFrom);
                }

                if (this.filtering.ceremonyTo) {
                    params.append('ceremonyTo', moment(this.filtering.ceremonyTo).format('YYYY-MM-DD'));
                }

                if (this.filtering.company_name) {
                    params.append('company_name', this.filtering.company_name);
                }

                if (this.filtering.location_name) {
                    params.append('location_name', this.filtering.location_name);
                }

                if (this.filtering.locationType) {
                    params.append('locationType', this.filtering.locationType);
                }

                if (this.ordering.companyCreatedAt) {
                    params.append('orderCompany', this.ordering.companyCreatedAt);
                }

                if (this.ordering.locationCreatedAt) {
                    params.append('orderLocation', this.ordering.locationCreatedAt);
                }

                const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
                window.history.pushState({}, '', newUrl);
            },

            loadFiltersFromUrl() {
                const params = new URLSearchParams(window.location.search);

                this.filtering.ceremonyFrom = params.get('ceremonyFrom') || null;
                this.filtering.ceremonyTo = params.get('ceremonyTo') || null;
                this.filtering.company_name = params.get('company_name') || null;
                this.filtering.location_name = params.get('location_name') ? Number(params.get('location_name')) : null;
                this.filtering.locationType = params.get('locationType') ? Number(params.get('locationType')) : null;

                this.ordering.companyCreatedAt = params.get('orderCompany') || 'created_at,desc';
                this.ordering.locationCreatedAt = params.get('orderLocation') || 'created_at,desc';
            },

            async fetchCompanies(param) {
                try {
                    const response = await this.$http.get('/api/backend/companies', {
                        params: {
                            page: param.page || 1,
                            order: param.order,
                            ceremonyFrom: this.filtering.ceremonyFrom,
                            ceremonyTo: this.filtering.ceremonyTo,
                            company_name: this.filtering.company_name,
                            location_name: this.filtering.location_name,
                            locationType: this.filtering.locationType
                        }
                    });
                    this.companies = response.data;
                } catch (error) {
                    console.error(error);
                    this.$notify({
                        group: 'default',
                        title: 'Bedrijven ophalen',
                        text: `De bedrijven konden niet worden opgehaald`,
                        type: 'error',
                        duration: 2000,
                        position: 'top center',
                    });
                }
            },

            async fetchLocations(param) {
                try {
                    const response = await this.$http.get('/api/backend/locations',{
                        params: {
                            page: param.page || 1,
                            order: param.order,
                            ceremonyFrom: this.filtering.ceremonyFrom,
                            ceremonyTo: this.filtering.ceremonyTo,
                            company_name: this.filtering.company_name,
                            location_name: this.filtering.location_name,
                            locationType: this.filtering.locationType
                        }
                    });
                    this.locations = response.data;
                } catch (error) {
                    console.error(error);
                    this.$notify({
                        group: 'default',
                        title: 'Locaties ophalen',
                        text: `De locaties konden niet worden opgehaald`,
                        type: 'error',
                        duration: 2000,
                        position: 'top center',
                    });
                }
            }
        }
    }
</script>

<style scoped lang="scss">

</style>
